import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Form from '@components/Form'
import { TEXT_SIZES } from '@helpers/constants'
import Text from '@components/Text'
import { theme } from '../../../../../tailwind.config'

const RadioButtonScale = (props) => {
  const { onSelect, minLabel, maxLabel, name, innerRef } = props
  const [selected, setSelected] = useState()

  return (
    <>
      <div className={'flex justify-between mb-2 mx-2'}>
        {[...Array(10).keys()].map((value) => (
          <Form.Radio
            key={value}
            onChange={(event) => {
              setSelected(parseInt(event.target.value))
              if (onSelect) onSelect(parseInt(event.target.value))
            }}
            name={name}
            value={value}
            ref={innerRef}
            style={{
              borderColor:
                selected === value ? undefined : theme.colors.lightDarkGrey,
            }}
          />
        ))}
      </div>

      <div className={'flex justify-between'}>
        <Text size={TEXT_SIZES.XSMALL}>{minLabel}</Text>
        <Text size={TEXT_SIZES.XSMALL}>{maxLabel}</Text>
      </div>
    </>
  )
}

RadioButtonScale.propTypes = {
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  name: PropTypes.string,
  onSelect: PropTypes.func,
  innerRef: PropTypes.func,
}

export default RadioButtonScale
